"use client";
import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';

const FormContainer = (_a) => {
    var { columnsCount = 1, children } = _a, cssProps = __rest(_a, ["columnsCount", "children"]);
    return (jsx("div", Object.assign({ style: {
            gridTemplateColumns: `repeat(${columnsCount}, minmax(0, 1fr))`,
        }, className: "grid w-full gap-5" }, cssProps, { children: children })));
};

export { FormContainer };
